import { Loader } from '@googlemaps/js-api-loader';

let googleMapsPromise = null;

// Global error handler for Google Maps API errors
const setupGoogleMapsErrorHandling = () => {
  // Override console.error to filter Google Maps errors
  const originalConsoleError = console.error;
  console.error = (...args) => {
    const errorMessage = args.join(' ');
    if (errorMessage.includes('b.EI') || 
        errorMessage.includes('undefined is not an object') ||
        errorMessage.includes('maps.googleapis.com') ||
        errorMessage.includes('bJ') ||
        errorMessage.includes('gN') ||
        errorMessage.includes('EI') ||
        errorMessage.includes('lF') ||
        errorMessage.includes('Places') ||
        errorMessage.includes('textSearch')) {
      // Suppress these internal Google Maps errors
      console.warn('Google Maps API internal error suppressed:', errorMessage);
      return;
    }
    // Call original console.error for other errors
    originalConsoleError.apply(console, args);
  };

  // Add global error handler for unhandled Google Maps errors
  const handleGoogleMapsError = (event) => {
    if (event.error && event.error.message && 
        (event.error.message.includes('bJ') || 
         event.error.message.includes('b.EI') ||
         event.error.message.includes('textSearch') ||
         event.error.message.includes('gN') ||
         event.error.message.includes('EI') ||
         event.error.message.includes('lF') ||
         event.error.message.includes('Places') ||
         event.error.message.includes('undefined is not an object'))) {
      console.warn('Google Maps API internal error caught:', event.error);
      event.preventDefault();
      return false;
    }
  };

  window.addEventListener('error', handleGoogleMapsError);
  window.addEventListener('unhandledrejection', handleGoogleMapsError);
};

let loaderInstance = null;

export const loadGoogleMaps = () => {
  // If already loaded, return immediately
  if (window.google && window.google.maps && window.google.maps.Map) {
    if (!googleMapsPromise) {
      googleMapsPromise = Promise.resolve(window.google);
    }
    return googleMapsPromise;
  }

  // If loading is in progress, return existing promise
  if (googleMapsPromise) {
    return googleMapsPromise;
  }

  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  
  if (!googleMapsApiKey) {
    console.warn('Google Maps API key not found. Maps will not work.');
    return Promise.reject(new Error('Google Maps API key not configured'));
  }

  // Setup error handling before loading
  setupGoogleMapsErrorHandling();

  // Create loader only once
  if (!loaderInstance) {
    loaderInstance = new Loader({
      apiKey: googleMapsApiKey,
      version: 'weekly',
      libraries: ['places'],
      language: 'en',
      region: 'US'
    });
  }

  googleMapsPromise = loaderInstance.load().then(() => {
    return window.google;
  }).catch((error) => {
    console.error('Error loading Google Maps API:', error);
    googleMapsPromise = null;
    loaderInstance = null;
    throw error;
  });

  return googleMapsPromise;
};

export const isGoogleMapsLoaded = () => {
  return !!(window.google && window.google.maps && window.google.maps.Map);
};

export const waitForGoogleMaps = () => {
  return new Promise((resolve, reject) => {
    if (isGoogleMapsLoaded()) {
      resolve(window.google);
      return;
    }

    const checkLoaded = setInterval(() => {
      if (isGoogleMapsLoaded()) {
        clearInterval(checkLoaded);
        resolve(window.google);
      }
    }, 100);

    // Timeout after 15 seconds
    setTimeout(() => {
      clearInterval(checkLoaded);
      reject(new Error('Google Maps loading timeout'));
    }, 15000);
  });
}; 